export const buttonTypes = {
  PHONE: 'PHONE',
  LINK: 'LINK',
  APP: 'APP',
};
